import { CONFIG_OPTION_TOAST_ERROR } from "common/toast";
import BreadCrumb from "components/Common/BreadCrumb";
import DropdownOption from "components/Common/DropdownOption";
import LabelWrapper from "components/Common/LabelWrapper";
import TableContainer from "components/Common/TableContainer";
import TooltipCustom from "components/Common/TooltipCustom";
import { TRANSACTIONS_TYPE_BUY_SELL_OPTIONS, TRANSACTIONS_TYPE_OBJECT_COLOR, TRANSACTIONS_TYPE_OBJECT_LABEL } from "helpers/constans";
import { formatNumberWithCommas, formatScientificNumber, formatTimeToAgo, formatTokenNumber } from "helpers/format";
import moment from "moment";
import { RenderContentDateRange } from "pages/Trade/components/RenderContentDateRange";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { Card, CardBody, CardHeader, Col, Container, Input, Row, Spinner } from "reactstrap";
import {
    NumberParam,
    StringParam,
    useQueryParams,
    withDefault,
} from "use-query-params";
import { getOptionPools as onGetOptionPools, getLogs as onGetLogs } from "../../../store/thunks";
import CopyWrapper from "components/Common/CopyWrapper";
import { Link } from "react-router-dom";
import { createSelector } from "reselect";
import DropdownTokenOption from "components/Common/DropdownTokenOption";
import DropdownPoolOption from "components/Common/DropdownPoolOption";

const TYPE_SELECT_DEFAULT: string = "id";

export default function TransactionLog() {
    const { t, i18n } = useTranslation();

    const isFirstLoadingPageRef = useRef<any>(true);

    const [typeShowPriceColumn, setTypeShowPriceColumn] = useState<'USD' | 'NATIVE'>('USD');

    const CHECKBOX_TRANSACTIONS_TYPE_OPTION_LANG = TRANSACTIONS_TYPE_BUY_SELL_OPTIONS.map((item) => ({ label: t(item.label), value: item.value }));

    const defaultStart = null; // moment(new Date(), "Y-MM-DD HH:mm").subtract(24, "hours").toDate();
    const defaultEnd = null; // moment(new Date(), "Y-MM-DD HH:mm").toDate();

    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        limit: withDefault(NumberParam, 100),
        page: withDefault(NumberParam, 1),
        // sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
        pair: withDefault(StringParam, ""),
        transactionType: withDefault(StringParam, CHECKBOX_TRANSACTIONS_TYPE_OPTION_LANG[0]?.value),
        fromDate: withDefault(StringParam, `${defaultStart ? moment(defaultStart).format('Y-MM-DD HH:mm') : ''}`),
        toDate: withDefault(StringParam, `${defaultEnd ? moment(defaultEnd).format('Y-MM-DD HH:mm') : ''}`),
        amountMin: withDefault(StringParam, ""),
        amountMax: withDefault(StringParam, ""),
        totalMin: withDefault(StringParam, ""),
        totalMax: withDefault(StringParam, ""),
        walletAddress: withDefault(StringParam, ""),
    });

    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => {
        return state.Pool;
    };

    const PoolProperties = createSelector(selectLayoutState, (state) => ({
        optionPools: state.optionPools || [],
        isOptionPoolSuccess: state.isOptionPoolSuccess,
        isOptionPoolLoading: state.isOptionPoolLoading,
        error: state.error,
    }));

    // Inside your component
    const { optionPools } = useSelector(PoolProperties);

    const [listPool, setListPool] = useState<any>([]);

    useEffect(() => {
        dispatch(onGetOptionPools({}));
    }, [dispatch]);

    const [objectPoolLogo, setObjectPoolLogo] = useState<any>({});

    const [makerFilter, setMakerFilter] = useState(query?.walletAddress || '');
    const [pairFilter, setPairFilter] = useState("");
    const [poolSearch, setPoolSearch] = useState<any>(null);
    const [typeFilter, setTypeFilter] = useState<any>(CHECKBOX_TRANSACTIONS_TYPE_OPTION_LANG?.find((item: any) => item?.value === query?.transactionType) || CHECKBOX_TRANSACTIONS_TYPE_OPTION_LANG[0]);

    const [amount, setAmount] = useState<any>({ min: "", max: "" });
    const [total, setTotal] = useState<any>({ min: "", max: "" });

    const [dateRangeSearch, setDateRangeSearch] = useState<any[]>([query?.fromDate ? moment(query?.fromDate || "", 'Y-MM-DD HH:mm').toDate() : null, query?.toDate ? moment(query?.toDate || "", 'Y-MM-DD HH:mm').toDate() : null])
    const [startDate, endDate] = dateRangeSearch;

    const [logList, setLogList] = useState<{ list: any[], total: number }>({ list: [], total: 0 });

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleQueryData = async () => {
        try {
            setIsLoading((prev) => true);
            const res: any = await onGetLogs(query);
            setLogList((prev: any) => ({
                list: Number(query?.page) === 1 ? (res?.data?.rows || []) : (prev?.list || []).concat(res?.data?.rows || []),
                total: res?.data?.total_rows || 0
            }));
            setIsLoading((prev) => false);
        } catch (error: any) {
            setIsLoading((prev) => false);
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
        }
    };

    const handleLoadMore = () => {
        setQuery({
            ...query,
            page: query?.page + 1,
        });
    };

    useEffect(() => {
        handleQueryData();
    }, [JSON.stringify(query)]);


    const convertTimeToAgo = (time: any) => {
        const localTime: any = moment.unix(time).tz(moment.tz.guess());
        const date = new Date(localTime);
        const now = new Date();
        const diff = now.getTime() - date.getTime();
        const minutes = Math.floor(diff / 1000 / 60);
        const hours = Math.floor(diff / 1000 / 60 / 60);
        const days = Math.floor(diff / 1000 / 60 / 60 / 24);

        if (days > 0) {
            return moment(date).tz(moment.tz.guess()).format("YYYY/MM/DD HH:mm");
        } else if (hours > 0) {
            return moment(date).tz(moment.tz.guess()).format("YYYY/MM/DD HH:mm");
        } else if (minutes > 0) {
            return `${minutes} ${t("minutes ago")}`;
        } else {
            return `${Math.floor(diff / 1000)}${t("s ago")}`;
        }
    };


    const searchData = () => {
        isFirstLoadingPageRef.current = false;
        setLogList((prev: any) => ({
            list: [],
            total: 0
        }));
        setQuery({
            ...query,
            transactionType: typeFilter?.value,
            walletAddress: makerFilter,
            fromDate: startDate ? `${moment(startDate).format("Y-MM-DD HH:mm")}` : '',
            toDate: endDate ? `${moment(endDate).format("Y-MM-DD HH:mm")}` : '',
            amountMin: amount?.min,
            amountMax: amount?.max,
            totalMin: total?.min,
            totalMax: total?.max,
            pair: poolSearch?.value || pairFilter || '',
            page: 1,
            time_request: + new Date()
        });
    };

    const resetData = () => {
        isFirstLoadingPageRef.current = false;
        const newQuery = {
            ...query,
            page: 1,
            transactionType: CHECKBOX_TRANSACTIONS_TYPE_OPTION_LANG[0]?.value,
            fromDate: '', // `${moment().subtract(24, "hours").format("Y-MM-DD HH:mm")}`,
            toDate: '', // `${moment().format("Y-MM-DD HH:mm")}`,
            walletAddress: '',
            pair: '',
            amountMin: '',
            amountMax: '',
            totalMin: '',
            totalMax: '',
            time_request: + new Date()
        };
        setLogList((prev: any) => ({
            list: [],
            total: 0,
        }));
        setMakerFilter("");
        setPairFilter("");
        setPoolSearch(null);
        setTypeFilter(CHECKBOX_TRANSACTIONS_TYPE_OPTION_LANG[0]);
        setAmount({ min: '', max: '' });
        setTotal({ min: '', max: '' });
        setDateRangeSearch([null, null]); // moment(newQuery?.fromDate || "", 'Y-MM-DD HH:mm').toDate(), moment(newQuery?.toDate || "", 'Y-MM-DD HH:mm').toDate()
        setQuery(newQuery, "push");
    };

    // const columnNameAmountToken = useMemo(() => {
    //     const _symbol = listPool?.find((_pool: any) => _pool?.value === query?.pair);
    //     const name1 = _symbol?.tokenSymbol1 ? `${t('Amount')} ${_symbol?.tokenSymbol1}` : t('Token Amount');
    //     const name2 = _symbol?.tokenSymbol2 ? `${t('Amount')} ${_symbol?.tokenSymbol2}` : t('Token Amount');
    //     return [name1, name2];
    // }, [query?.pair, listPool, i18n?.language]);

    // Column
    const columns = useMemo(
        () => [
            {
                Header: t("Date"),
                accessor: "timestamp",
                filterable: true,
                sortable: false,
                thWidth: 150,
                Cell: (cell: any) => {
                    const _date_time: string = formatTimeToAgo(cell?.value, t, true);
                    const _date_times: string[] = String(_date_time)?.split(' ');
                    return (<>
                        <div style={{ minWidth: "130px" }}>
                            <div className="text-muted">
                                {_date_times?.[1] || '-'}
                            </div>
                            <div>
                                {_date_times?.[0] || '-'}
                            </div>
                        </div>
                    </>
                    )
                },
            },

            {
                Header: t('Pair'),
                accessor: "logo",
                filterable: true,
                sortable: false,
                thWidth: 190,
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const pairInfo = objectPoolLogo?.[`${item?.pair}`];
                    return (
                        <>
                            <div className="d-flex space-x-2 position-relative align-items-center">
                                <TooltipCustom
                                    title={pairInfo?.symbol_token_1 || ''}
                                    className="d-inline-block vertical-align-middle"
                                    style={{ transform: 'translateY(2px)' }}
                                >
                                    <span className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center text-xs text-gray-900">
                                        {!!pairInfo?.logo_token_1 ? <img src={pairInfo?.logo_token_1} alt="Token Icon" className="w-10 h-10 rounded-full" /> : String(pairInfo?.symbol_token_1)?.split('')?.[0] || ''}
                                    </span>
                                </TooltipCustom>
                                <div className="ms-2">
                                    <div><strong>{pairInfo?.symbol_token_1 || '-'}</strong> <span className="text-muted">/</span> <span className="fs-12 text-muted">{pairInfo?.symbol_token_2 || '-'}</span></div>
                                    <div className="fs-12 text-muted">
                                        <Link to={`https://solscan.io/account/${item?.pair}`} target="_blank" className="d-inline-block">
                                            <CopyWrapper
                                                isShow={true}
                                                contentCopy={item?.pair}
                                            >
                                                {item?.pair ? (
                                                    <span>
                                                        {item?.pair?.slice(0, 4) +
                                                            "..." +
                                                            item?.pair?.slice(-3)}
                                                    </span>
                                                ) : (
                                                    ""
                                                )}
                                            </CopyWrapper>
                                        </Link>
                                    </div>
                                </div>
                                <div className="position-absolute" style={{ bottom: 0, transform: 'translate(10px, 4px)' }}>
                                    <TooltipCustom
                                        title={pairInfo?.symbol_token_2 || ''}
                                        className="d-inline-block vertical-align-middle"
                                        style={{ transform: 'translateY(2px)' }}
                                    >
                                        <span className="w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center text-xs text-gray-900">
                                            {!!pairInfo?.logo_token_2 ? <img src={pairInfo?.logo_token_2} alt="Token Icon" className="w-6 h-6 rounded-full" /> : String(pairInfo?.symbol_token_2)?.split('')?.[0] || ''}
                                        </span>
                                    </TooltipCustom>
                                </div>
                            </div>
                        </>
                    )
                },
            },
            {
                Header: t("Type"),
                accessor: "transactionType",
                filterable: true,
                sortable: false,
                thWidth: 120,
                thClass: "text-center",
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>
                            <div style={{ minWidth: "100px" }} className="row-transition-bg-colors font-semibold text-center">
                                <span
                                    className={TRANSACTIONS_TYPE_OBJECT_COLOR[`${cell?.value}`] || '-'
                                    }
                                >
                                    {t(TRANSACTIONS_TYPE_OBJECT_LABEL[`${cell?.value}`] || '-')}
                                </span>
                            </div>
                        </>
                    );
                },
            },
            // {
            //     Header: t("Price") + ' (' + t('Native Price') + ')',
            //     accessor: "baseQuotePrice",
            //     filterable: true,
            //     sortable: false,
            //     thWidth: 150,
            //     thClass: "text-end",
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         const pairInfo = objectPoolLogo?.[`${item?.pair}`];
            //         return (
            //             <>
            //                 <div style={{ minWidth: "120px" }} className="row-transition-bg-colors font-semibold text-end">
            //                     <span
            //                         className={TRANSACTIONS_TYPE_OBJECT_COLOR[`${item?.transactionType}`] || '-'
            //                         }
            //                     >
            //                         {['buy', 'sell']?.includes(item?.transactionType) ? formatScientificNumber(item?.baseQuotePrice, 4, '') : '-'}
            //                     </span>
            //                 </div>
            //             </>
            //         );
            //     },
            // },
            {
                Header: t("Price"),
                accessor: "baseTokenPriceUsd",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: "text-end",
                thComponent: () => (
                    <div className="flex justify-content-end align-items-center space-x-2 cursor-pointer"
                        onClick={() => {
                            setTypeShowPriceColumn((_prev) => (_prev === 'USD' ? 'NATIVE' : 'USD'));
                        }}
                    >
                        <span >{t("Price")}</span>
                        <TooltipCustom
                            title={t('Toggle USD/Native Price')}
                            className="d-inline-block vertical-align-middle ms-1"
                            style={{ transform: 'translateY(2px)' }}
                        >
                            {typeShowPriceColumn === 'USD' ? <i className={`fs-16 bx bx-dollar-circle`} /> :
                                <i className={`fs-16 bx bx-bolt-circle`} />}
                        </TooltipCustom>
                    </div>
                ),
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>
                            <div style={{ minWidth: "120px" }} className="row-transition-bg-colors font-semibold text-end">
                                <span
                                    className={TRANSACTIONS_TYPE_OBJECT_COLOR[`${item?.transactionType}`] || '-'
                                    }
                                >
                                    {['buy', 'sell']?.includes(item?.transactionType) ? (
                                        typeShowPriceColumn === 'USD' ? formatScientificNumber(item?.baseTokenPriceUsd, Number(item?.baseTokenPriceUsd) < 1 ? 6 : 4, '$') : formatScientificNumber(item?.baseQuotePrice, 4, '')
                                    ) : '-'}
                                </span>
                            </div>
                        </>
                    );
                },
            },
            {
                Header: t("Label_Total"),
                accessor: "totalValueUsd",
                filterable: true,
                sortable: false,
                thWidth: 150,
                thClass: "text-end",
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>
                            <div style={{ minWidth: "120px" }} className="row-transition-bg-colors font-semibold text-end">
                                <span
                                    className={TRANSACTIONS_TYPE_OBJECT_COLOR[`${item?.transactionType}`] || '-'
                                    }
                                >
                                    {['buy', 'sell']?.includes(item?.transactionType) ? formatScientificNumber(item?.totalValueUsd, Number(item?.totalValueUsd) > 9 ? 2 : 4, '$') : '-'}
                                </span>
                            </div>
                        </>
                    );
                },
            },
            {
                Header: t("Token Amount"),
                accessor: "baseTokenAmount",
                filterable: true,
                sortable: false,
                thWidth: 180,
                thClass: "text-end",
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const pairInfo = objectPoolLogo?.[`${item?.pair}`];
                    return (
                        <>
                            <div style={{ minWidth: "160px" }} className="row-transition-bg-colors font-semibold d-flex flex-column align-items-end justify-content-end">
                                <div className={TRANSACTIONS_TYPE_OBJECT_COLOR[`${item?.transactionType}`] || '-'}>
                                    {formatScientificNumber(Number(item?.baseTokenAmount) > 100000 ? Number(item?.baseTokenAmount).toFixed(0) : item?.baseTokenAmount, Number(item?.baseTokenAmount) < 1 ? 4 : 2, '')}
                                </div>
                                <div className=" d-flex align-items-center opacity-90">
                                    <span className="text-muted font-normal me-1 fs-14"> {pairInfo?.symbol_token_1 || ''}</span> <img src={pairInfo?.logo_token_1} alt="Token Icon" className="w-[14px] h-[14px] rounded-full" />
                                </div>
                            </div>
                        </>
                    );
                },
            },
            {
                Header: t("Token Amount"),
                accessor: "quoteTokenAmount",
                filterable: true,
                sortable: false,
                thWidth: 180,
                thClass: "text-end",
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const pairInfo = objectPoolLogo?.[`${item?.pair}`];
                    return (
                        <>
                            <div style={{ minWidth: "160px" }} className="row-transition-bg-colors font-semibold d-flex flex-column align-items-end justify-content-end">
                                <div className={TRANSACTIONS_TYPE_OBJECT_COLOR[`${item?.transactionType}`] || '-'}>
                                    {formatScientificNumber(Number(item?.quoteTokenAmount) > 100000 ? Number(item?.quoteTokenAmount).toFixed(0) : item?.quoteTokenAmount, Number(item?.quoteTokenAmount) < 1 ? 4 : 2, '')}
                                </div>
                                <div className=" d-flex align-items-center opacity-70">
                                    <span className="text-muted font-normal me-1 fs-14"> {pairInfo?.symbol_token_2 || ''}</span> <img src={pairInfo?.logo_token_2} alt="Token Icon" className="w-[14px] h-[14px] rounded-full" />
                                </div>
                            </div>
                        </>
                    );
                },
            },
            {
                Header: t("Maker"),
                accessor: "walletAddress",
                filterable: true,
                sortable: false,
                thWidth: 230,
                thClass: "text-end",
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>
                            <div style={{ minWidth: "200px" }} className="text-end">
                                <CopyWrapper
                                    isShow={true}
                                    contentCopy={item?.walletAddress}
                                >
                                    <span>
                                        {item?.walletAddress?.slice(0, 8) +
                                            "..." +
                                            item?.walletAddress?.slice(-6)}
                                    </span>
                                </CopyWrapper>
                            </div>
                        </>
                    );
                },
            },
            {
                Header: t("TXN"),
                accessor: "transactionHash",
                filterable: true,
                sortable: false,
                thWidth: 230,
                thClass: "text-end",
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>
                            <div style={{ minWidth: "200px" }} className="text-end">
                                <Link to={`https://solscan.io/tx/${item?.transactionHash}`} target="_blank" className="d-inline-block">
                                    <CopyWrapper
                                        isShow={true}
                                        contentCopy={item?.transactionHash}
                                    >
                                        {" "}
                                        <span>
                                            {item?.transactionHash?.slice(0, 8) +
                                                "..." +
                                                item?.transactionHash?.slice(-6)}
                                        </span>
                                    </CopyWrapper>
                                </Link>
                            </div>
                        </>
                    );
                },
            },
            {
                Header: t("Label_Pool"),
                accessor: "pair",
                filterable: true,
                sortable: false,
                thWidth: 230,
                thClass: "text-end",
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <>
                            <div style={{ minWidth: "200px" }} className="text-end">
                                <Link to={`https://solscan.io/account/${item?.pair}`} target="_blank" className="d-inline-block">
                                    <CopyWrapper
                                        isShow={true}
                                        contentCopy={item?.pair}
                                    >
                                        {item?.pair ? (
                                            <span>
                                                {item?.pair?.slice(0, 8) +
                                                    "..." +
                                                    item?.pair?.slice(-6)}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                    </CopyWrapper>
                                </Link>
                            </div>
                        </>
                    );
                },
            },
        ],
        [i18n?.language, query, objectPoolLogo, typeShowPriceColumn]
    );


    useEffect(() => {
        const _obj = (optionPools || [])?.reduce((_ob: any, _p: any) => {
            return ({
                ..._ob,
                [`${_p?.pairAddress}`]: {
                    name: _p?.pairLabel || '',
                    symbol_token_1: _p?.tokens?.[0]?.tokenSymbol || '',
                    logo_token_1: _p?.tokens?.[0]?.tokenLogo || '',
                    decimal_token_1: _p?.tokens?.[0]?.tokenDecimals || '4',
                    symbol_token_2: _p?.tokens?.[1]?.tokenSymbol || '',
                    logo_token_2: _p?.tokens?.[1]?.tokenLogo || '',
                    decimal_token_2: _p?.tokens?.[1]?.tokenDecimals || '4',
                }
            });
        }, {});
        const list = (optionPools || [])?.map((item: any) => {
            return {
                value: item?.pairAddress,
                label: item?.pairLabel,
                logo1: item?.tokens?.[0]?.tokenLogo,
                logo2: item?.tokens?.[1]?.tokenLogo,
                tokenSymbol1: item?.tokens?.[0]?.tokenSymbol,
                tokenSymbol2: item?.tokens?.[1]?.tokenSymbol,
                pair: item?.pairLabel || '',
            };
        });


        setListPool(list);
        setObjectPoolLogo(() => _obj);
        if (query?.pair) {
            const pool_search = list?.find((_pool: any) => _pool?.value === query?.pair) || null;
            setPoolSearch(pool_search);
            setPairFilter(!!pool_search?.value ? '' : query?.pair);
        }
    }, [optionPools]);

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 });
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setQuery((_prev: any) => {
            return { ..._prev, ...sortBy };
        });
    }, []);

    useEffect(() => {
        document.title = `${t("Monitoring")} - ${t("Transaction Log")}`;
        document.body.classList.remove("vertical-sidebar-enable");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={t("Transaction Log")} pageTitle={t("Monitoring")} />
                    <Row>
                        <Col lg={12}>
                            <Card
                                id="customerList"
                                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
                            >
                                <CardHeader className="border-0">
                                    <Row className="g-4 align-items-center">
                                        <div className="col-5 con-sm-6">
                                            <div>
                                                <h5 className="card-title mb-0">
                                                    <span className="me-2">{t("Total")}:</span>
                                                    {(isLoading && (Number(query?.page) === 1)) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                        start={0}
                                                        end={logList?.total || 0}
                                                        duration={1}
                                                        className="text-primary"
                                                    />)}
                                                </h5>
                                            </div>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                                    <Row>
                                        <Col sm={12}
                                            md={6}
                                            xl={3}
                                            xxl={3}
                                            className="mt-3 mt-md-2"
                                        >
                                            <LabelWrapper label={t('Label_Pool')} isShow={true}>
                                                <DropdownPoolOption
                                                    isMultiLang
                                                    name="pool"
                                                    dataList={listPool}
                                                    initialValue={poolSearch || null}
                                                    onChangeSelect={(event: any) => { setPoolSearch((_prev: any) => event); }}
                                                    className="dropdown-status-rounded z-hight"
                                                    classNamePrefix="name-prefix"
                                                    isShowMore={true}
                                                    // className="bg-[#fff]"
                                                    labelTop=""
                                                    isHasOptionAll={true}
                                                    optionAll={{
                                                        label: t('All'),
                                                        value: ''
                                                    }}
                                                />
                                            </LabelWrapper>
                                        </Col>

                                        <Col
                                            sm={6}
                                            md={6}
                                            xl={3}
                                            xxl={3}
                                            className="items-center mt-3 mt-xl-2"
                                        >
                                            <LabelWrapper label={t("Label_Total")} isShow={true}>
                                                <div className="d-flex gap-2">
                                                    <Input
                                                        type="number"
                                                        className="form-control search"
                                                        placeholder={`${t("Label_Min")}`}
                                                        value={total?.min}
                                                        onChange={(e) =>
                                                            setTotal((_prev: any) => ({ ..._prev, min: e.target.value }))
                                                        }
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                    <p className="py-2">→</p>
                                                    <Input
                                                        type="number"
                                                        className="form-control search"
                                                        placeholder={`${t("Label_Max")}`}
                                                        value={total?.max}
                                                        onChange={(e) =>
                                                            setTotal((_prev: any) => ({ ..._prev, max: e.target.value }))
                                                        }
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </LabelWrapper>
                                        </Col>
                                        <Col
                                            sm={6}
                                            md={6}
                                            xl={3}
                                            xxl={3}
                                            className="mt-3 mt-xl-2"
                                        >
                                            <LabelWrapper label={t("Label_Amount")} isShow={true}>
                                                <div className="d-flex gap-2">
                                                    <Input
                                                        type="text"
                                                        className="form-control search"
                                                        placeholder={`${t("Label_Min")}`}
                                                        value={amount?.min}
                                                        onChange={(e) =>
                                                            setAmount((_prev: any) => ({ ..._prev, min: e.target.value }))
                                                        }
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                    <p className="py-2">→</p>
                                                    <Input
                                                        type="text"
                                                        className="form-control search"
                                                        placeholder={`${t("Label_Max")}`}
                                                        value={amount?.max}
                                                        onChange={(e) =>
                                                            setAmount((_prev: any) => ({ ..._prev, max: e.target.value }))
                                                        }
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                searchData();
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </LabelWrapper>
                                        </Col>

                                        <Col
                                            sm={12}
                                            md={6}
                                            xl={3}
                                            xxl={3}
                                            className="mt-3 mt-xl-2"
                                        >
                                            <LabelWrapper label={t("DateTime")} isShow={true}>
                                                <RenderContentDateRange
                                                    startDate={startDate}
                                                    endDate={endDate}
                                                    setDateRangeSearch={setDateRangeSearch}
                                                />
                                            </LabelWrapper>
                                        </Col>

                                        <Col
                                            sm={6}
                                            md={6}
                                            xl={3}
                                            xxl={3}
                                            className="mt-3 order-0 order-sm-2 order-md-0"
                                        >
                                            <LabelWrapper label={t("Type")}>
                                                <DropdownOption
                                                    isMultiLang
                                                    name="type"
                                                    dataList={CHECKBOX_TRANSACTIONS_TYPE_OPTION_LANG}
                                                    initialValue={typeFilter || CHECKBOX_TRANSACTIONS_TYPE_OPTION_LANG?.[0]}
                                                    onChangeSelect={(event: any) => {
                                                        setTypeFilter((_prev: any) => event);
                                                    }}
                                                    className="dropdown-status-rounded z-hight"
                                                    classNamePrefix="name-prefix"
                                                    labelTop="Type"
                                                />
                                            </LabelWrapper>
                                        </Col>

                                        <Col
                                            sm={12}
                                            md={6}
                                            xl={3}
                                            xxl={3}
                                            className="mt-3 order-0 order-sm-1 order-md-0"
                                        >
                                            <LabelWrapper label={t("Label_Pool_Number")} isShow={true}>
                                                <Input
                                                    type="text"
                                                    className="form-control search"
                                                    placeholder={`${t("Label_Pool_Number")}...`}
                                                    value={pairFilter}
                                                    onChange={(e) => setPairFilter(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            searchData();
                                                        }
                                                    }}
                                                />
                                            </LabelWrapper>
                                        </Col>

                                        <Col
                                            sm={12}
                                            md={6}
                                            xl={3}
                                            xxl={3}
                                            className="mt-3 order-0 order-sm-1 order-md-0"
                                        >
                                            <LabelWrapper label={t("Maker")} isShow={true}>
                                                <Input
                                                    type="text"
                                                    className="form-control search"
                                                    placeholder={`${t("Maker")}...`}
                                                    value={makerFilter}
                                                    onChange={(e) => setMakerFilter(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            searchData();
                                                        }
                                                    }}
                                                />
                                            </LabelWrapper>
                                        </Col>

                                        <Col
                                            sm={6}
                                            md={6}
                                            xl={3}
                                            xxl={3}
                                            className="hstack gap-1 order-0 order-sm-3 order-md-0 justify-content-center justify-content-sm-end mt-3 "
                                        >
                                            <div>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary me-2 bg-[#009ef7] !hover:bg-[#0086d2]"
                                                    onClick={searchData}
                                                    disabled={isLoading}
                                                >
                                                    <i className="ri-search-line align-bottom me-1"></i>{" "}
                                                    {t("Button Search")}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary fs-14 bg-[#878a99] !hover:bg-[#737582]"
                                                    onClick={() => {
                                                        // emitSendMessage({ pool: 'aaaaaaaaaaaaaaaaa' });
                                                        resetData()
                                                    }}
                                                    disabled={isLoading}
                                                >
                                                    <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                    {t("Button Reset")}
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                    {/* <Row className="g-4 align-items-center mt-0">
                                        <Col sm={6} md={8} xl={9} xxl={10} className="hstack gap-1 justify-content-center justify-content-sm-start mt-3">
                                            <div>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary me-2  bg-[#009ef7] hover:bg-[#0086d2]"
                                                    onClick={searchData}
                                                    disabled={isLoading}
                                                >
                                                    <i className="ri-search-line align-bottom me-1"></i>{" "}
                                                    {t('Button Search')}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary fs-14  bg-[#878a99] hover:bg-[#737582]"
                                                    onClick={resetData}
                                                >
                                                    <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                    {t('Button Reset')}
                                                </button>
                                            </div>
                                        </Col>
                                    </Row> */}
                                </div>
                                <CardBody className="pt-0 px-0">
                                    <InfiniteScroll
                                        dataLength={logList?.list?.length || 0}
                                        next={handleLoadMore}
                                        scrollableTarget='scrollableDiv'
                                        hasMore={logList && logList?.list?.length < logList?.total ? true : false}
                                        loader={''} // loader={<LoadingListNotify />}
                                        scrollThreshold={'50%'}
                                    >
                                        <div className="mx-3 my-4 mt-3">
                                            <TableContainer
                                                className="custom-header-css"
                                                divClass="table-responsive table-card"
                                                tableClass="align-middle sticky-table-wallet"
                                                theadClass="table-light"
                                                columns={columns}
                                                data={logList?.list?.length ? logList?.list : []}
                                                customPageSize={query.limit}
                                                customPageIndex={query.page - 1}
                                                totalRecords={logList?.total}
                                                // customPageCount={1}
                                                customPageCount={1}
                                                handleChangePage={handleChangePage}
                                                manualSorting={true}
                                                sorting={{
                                                    sort_by: query.sort_by,
                                                    order_by: query.order_by,
                                                }}
                                                handleChangeSorting={handleChangeSorting}
                                                isLoading={isLoading}
                                                isShowPagination={false}
                                                isShowLoadingBottom={query.page > 1}
                                                isScrollToTop={false}
                                            />
                                        </div>
                                    </InfiniteScroll>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ToastContainer autoClose={2000} limit={1} />
            </div>
        </React.Fragment>
    );
}
